import React, { ReactNode } from "react";
import styled from "styled-components";
import Button from "common/Buttons/Button";
import { getNewLookTokens, newLookType } from "common/NewLook/tokens.ts";

interface GroupsListMessageProps {
  title: ReactNode;
  description?: ReactNode;
  actionLabel?: ReactNode;
  onAction?: () => void;
}

/** An empty or error state inside a panel: title, one line, one action. */
const GroupsListMessage = ({
  title,
  description,
  actionLabel,
  onAction,
}: GroupsListMessageProps) => (
  <Wrapper role="status">
    <Title>{title}</Title>
    {description && <Description>{description}</Description>}
    {actionLabel && onAction && (
      <Action onClick={onAction} size="middle">
        {actionLabel}
      </Action>
    )}
  </Wrapper>
);

export default GroupsListMessage;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  padding: 40px 20px;
  text-align: center;
`;
const Title = styled.div`
  ${newLookType.panelTitle};
  color: ${(p) => getNewLookTokens(p.theme).ink};
`;
const Description = styled.div`
  max-width: 400px;
  ${newLookType.meta};
  color: ${(p) => getNewLookTokens(p.theme).muted};
`;
const Action = styled(Button)`
  margin-top: 12px;
`;
